import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Flyout from 'common/components/Flyout';
export default class HelpFlyout extends React.Component {
  render() {
    const ZENDESK_LINK = 'https://support.socrata.com/hc/en-us/articles/115005683108';

    return (
      <div className="catalog-landing-page-help-flyout">
        <Flyout {...this.props}>
          <a href={ZENDESK_LINK} target="_blank" aria-label={_.get(I18n, 'activation.whats_this')}>
            <span className="socrata-icon-question"></span>
          </a>
        </Flyout>
      </div>
    );
  }
}

HelpFlyout.propTypes = {
  left: PropTypes.bool,
  right: PropTypes.bool,
  text: PropTypes.string.isRequired
};

HelpFlyout.defaultProps = {
  left: false,
  right: false
};
